// A card of the results of the search (3/11): opened, it shows the places
// where the words were found, with more text around them (`previews` of
// GET /search/v2, already in the card: nothing more is asked), and «Leggi
// altro» to the document opened on the words. A hit without places (a match
// in the title only, a document without text) opens as a card of the News.
import { useLocation } from "react-router";

import { NewsCard, type NewsCardProps } from "../../components/news/NewsCard";
import { pageLinkState } from "../../lib/navigation";
import { ExpandedNewsCard, ReadMore } from "../news/ExpandedNewsCard";

export function SearchCard(props: NewsCardProps) {
  const location = useLocation();
  if (props.news.body.length === 0) return <ExpandedNewsCard {...props} />;
  return (
    <NewsCard
      {...props}
      detail={{ status: "ready", notices: [], more: <ReadMore news={props.news} state={pageLinkState(location)} /> }}
    />
  );
}
